import React, { useState } from "react";
import UploadIcon from "@mui/icons-material/Upload";
import SearchBar from "./searchBar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import "./header.css";
import {
  Box,
  Stack,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import { config } from "../App";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4CA3FC",
      darker: "#053e85",
    },
    secondary: {
      main: "#f3e5f5",
    },
  },
});

const genre = [
  {
    value: "All",
    label: "All",
  },
  {
    value: "Education",
    label: "Education",
  },
  {
    value: "Sports",
    label: "Sports",
  },
  {
    value: "Movies",
    label: "Movies",
  },
  {
    value: "Comedy",
    label: "Comedy",
  },
  {
    value: "Lifestyle",
    label: "Lifestyle",
  },
];

const contentRating = [
  {
    value: "Anyone",
    label: "Anyone",
  },
  {
    value: "7+",
    label: "7+",
  },
  {
    value: "12+",
    label: "12+",
  },
  {
    value: "16+",
    label: "16+",
  },
  {
    value: "18+",
    label: "18+",
  },
];

const Header = ({ navSetFilter, inVideoPage }) => {
  const [videolink, setVideolink] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [title, setTitle] = useState("");
  const [genretype, setGenretype] = useState("");
  const [age, setAge] = useState("");
  const [date, setDate] = useState("");
  const [open, setOpen] = useState(false);

  const dateStr = date;
  const newdate = new Date(dateStr);

  const formattedDate = newdate.toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    const isYoutubeLink = youtubeRegex.test(videolink);

    if (!isYoutubeLink) {
      console.log("Invalid YouTube video link");
      return;
    }

    try {
      const res = await axios.post(`${config.endpoint}/videos`, {
        videoLink: videolink,
        title: title,
        genre: genretype,
        contentRating: age,
        releaseDate: formattedDate,
        previewImage: thumbnail,
      });
      handleClose();
      console.log(res);
    } catch (e) {
      handleClose();
      console.log(e.response);
    }
  };

  return (
    <Box>
      <Stack
        className="text-color Navbar"
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ position: "sticky", background: " #313131", top: 0 }}
      >
        <Link className="link" to="/">
          <Typography variant="h5" sx={{ color: "error.main", fontSize: 22 }}>
            <span className="shadow">X</span> <span className="text-color">Flix</span>
          </Typography>
        </Link>
        {inVideoPage ? null : (
          <>
            <SearchBar
              searchSetFilter={navSetFilter}
            />
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                color="primary"
                sx={{ color: "#f3e5f5" }}
                startIcon={<UploadIcon color="secondary" />}
              >
                Upload
              </Button>
            </ThemeProvider>
            <Dialog open={open} onClose={handleClose}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  bgcolor: "#313131",
                  color: "#ffffff"
                }}
              >
                <DialogTitle>Upload Video</DialogTitle>
                <CloseIcon
                  sx={{ pt: "18px", pr: "7px"}}
                  onClick={handleClose}
                />
              </Box>
              <DialogContent sx={{ p: "10px" }}>
                <FormControl sx={{ width: "300px", color: "white" }}>
                  <TextField
                    helperText="This link will be used to derive the video"
                    id="demo-helper-text-aligned"
                    label="Video Link"
                    value={videolink}
                    onInput={(e) => setVideolink(e.target.value)}
                    name=""
                    type="text"
                    sx={{ pb: "12px" }}
                  />
                  <TextField
                    helperText="This link will be used to preview the thumbnail image"
                    id="demo-helper-text-aligned"
                    label="Thumbnail Image Link"
                    value={thumbnail}
                    onInput={(e) => setThumbnail(e.target.value)}
                    name=""
                    type="text"
                    sx={{ pb: "12px" }}
                  />
                  <TextField
                    helperText="The title will be the representative text for video"
                    id="demo-helper-text-aligned"
                    value={title}
                    onInput={(e) => setTitle(e.target.value)}
                    name=""
                    type="text"
                    sx={{ pb: "12px" }}
                  />

                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Genre"
                    defaultValue="All"
                    value={genretype}
                    onChange={(e) => setGenretype(e.target.value)}
                    helperText="Genre will help in categorizing your videos"
                    sx={{ pb: "12px" }}
                  >
                    {genre.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Suitable age group for the clip"
                    defaultValue="Anyone"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    helperText="This will be used to filter videos on age group suitability"
                    sx={{ pb: "12px" }}
                  >
                    {contentRating.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    sx={{ pb: "12px" }}
                  >
                    <DesktopDatePicker
                      label="Release date"
                      inputFormat="MM/DD/YYYY"
                      helperText="This will be used to sort videos"
                      onChange={(e) => setDate(e.$d)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
              </DialogContent>
              <Box sx={{ display: "flex", flexDirection: "row", p: "10px", bgcolor: "#313131"}}>
                <Button
                  variant="contained"
                  color="error"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Upload Video
                </Button>
                <Button onClick={handleClose} sx={{color: "#ffffff"}}>CanceL</Button>
              </Box>
            </Dialog>
          </>
        )}
      </Stack>
    </Box>
  );
};

export default Header;
